import React, { useEffect, useRef, useState } from "react";
import { CheckCircle2, Loader2, XCircle, Clock } from "lucide-react";

/* 短信投递状态：发送成功后轮询 Twilio 状态（最多 ~40s），显示 排队 / 已发出 / 已送达 / 未送达（原因） */
export function useSmsDelivery(api) {
  const [st, setSt] = useState(null); // {sid, status, statusZh, hint, final}
  const timer = useRef(null);
  const stop = () => { if (timer.current) { clearTimeout(timer.current); timer.current = null; } };
  const track = (sid) => {
    stop();
    if (!sid || !String(sid).startsWith("SM") && !String(sid).startsWith("MM")) { setSt(null); return; }
    setSt({ sid, status: "queued", statusZh: "已提交", final: false });
    let n = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/telephony/sms-status/${sid}`);
        setSt(data);
        if (data.final) return;
      } catch { /* keep polling */ }
      if (++n < 14) timer.current = setTimeout(tick, n < 4 ? 2000 : 3500);
      else setSt((p) => (p && !p.final ? { ...p, timeout: true } : p));
    };
    timer.current = setTimeout(tick, 1500);
  };
  useEffect(() => stop, []);
  return { st, track, clear: () => { stop(); setSt(null); } };
}

export function SmsDeliveryBadge({ st, zh }) {
  if (!st) return null;
  const ok = st.status === "delivered" || st.status === "read";
  const bad = st.status === "undelivered" || st.status === "failed";
  const cls = ok ? "text-emerald-700 bg-emerald-50 border-emerald-200" : bad ? "text-red-700 bg-red-50 border-red-200" : "text-slate-600 bg-slate-50 border-slate-200";
  const Icon = ok ? CheckCircle2 : bad ? XCircle : st.timeout ? Clock : Loader2;
  return (
    <div className={`rounded-md border px-2 py-1 text-[11px] flex items-start gap-1.5 ${cls}`} data-testid="sms-delivery-status" data-status={st.status || ""}>
      <Icon className={`h-3.5 w-3.5 mt-0.5 shrink-0 ${!ok && !bad && !st.timeout ? "animate-spin" : ""}`} />
      <span>
        <b>{zh ? (st.statusZh || st.status) : (st.status || "")}</b>{st.to ? ` · ${st.to}` : ""}
        {bad && st.hint && <span className="block">{st.hint}</span>}
        {!ok && !bad && st.timeout && <span className="block text-slate-500">{zh ? "运营商回执较慢，可稍后在坐席详情「短信记录」查看。" : "Carrier receipt pending."}</span>}
      </span>
    </div>
  );
}
